import React, { memo } from 'react';
import { isValidString } from '../../global/utils/logger';
import { string } from 'prop-types';
const SearchLazyShimmer = props => {
  const element = document?.querySelector(`.${props?.pageTypeClass}`);
  const isShimmerEnabled = element?.dataset?.isshimmerenabled;
  const layout = element?.dataset?.layout;  
  const isGrid = layout == 'grid';
  const shimmerContainer = document.querySelector('.search-shimmer:not(.suspense-fallback)');
  const isAemShimmerVisible = window?.getComputedStyle(shimmerContainer)?.display === 'block';

    if(!isValidString(isShimmerEnabled) || isAemShimmerVisible) {
        return <></>;
    }
    return (
        <section class="search-shimmer">
            <div class="container">
                <div class="row">
                    <div class="col-lg-3">
                        <div class="plp__filter plp__left-filter">
                            <div class="plp__left-filterbutton-shimmer shimmer"></div>
                            <div class="plp__left-dropdown-shimmer shimmer"></div>
                            <div class="plp__filter-title-shimmer shimmer"></div>
                            <div class="filter__title-shimmer shimmer"></div>
                            <div class="filter__title-shimmer shimmer"></div>
                        </div>
                    </div>
                    <div class="col-lg-9">
                        <div class="plp__right-filter">
                            <div class="plp__right-filter-buttonselect-shimmer shimmer"></div>
                        </div>

                        {isGrid ? (
                            <div class="row plp__list">
                                <div class="col-md-3 col-lg-4 col-6 plp__item">
                                    <div class="product__tile__react">
                                        <div class="producttile">
                                            <div>
                                                <div class="producttile-img shimmer"></div>
                                                <div>
                                                    <div class="producttile__catclass producttile-catclass eyebrow shimmer"></div>
                                                    <div class="producttile__productname producttile-productname shimmer"></div>
                                                </div>
                                            </div>
                                            <div class="producttile__footer producttile-footer shimmer"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-lg-4 col-6 plp__item">
                                    <div class="product__tile__react">
                                        <div class="producttile">
                                            <div>
                                                <div class="producttile-img shimmer"></div>
                                                <div>
                                                    <div class="producttile__catclass producttile-catclass eyebrow shimmer"></div>
                                                    <div class="producttile__productname producttile-productname shimmer"></div>
                                                </div>
                                            </div>
                                            <div class="producttile__footer producttile-footer shimmer"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-lg-4 col-6 plp__item">
                                    <div class="product__tile__react">
                                        <div class="producttile">
                                            <div>
                                                <div class="producttile-img shimmer"></div>
                                                <div>
                                                    <div class="producttile__catclass producttile-catclass eyebrow shimmer"></div>
                                                    <div class="producttile__productname producttile-productname shimmer"></div>
                                                </div>
                                            </div>
                                            <div class="producttile__footer producttile-footer shimmer"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-lg-4 col-6 plp__item">
                                    <div class="product__tile__react">
                                        <div class="producttile">
                                            <div>
                                                <div class="producttile-img shimmer"></div>
                                                <div>
                                                    <div class="producttile__catclass producttile-catclass eyebrow shimmer"></div>
                                                    <div class="producttile__productname producttile-productname shimmer"></div>
                                                </div>
                                            </div>
                                            <div class="producttile__footer producttile-footer shimmer"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-lg-4 col-6 plp__item">
                                    <div class="product__tile__react">
                                        <div class="producttile">
                                            <div>
                                                <div class="producttile-img shimmer"></div>
                                                <div>
                                                    <div class="producttile__catclass producttile-catclass eyebrow shimmer"></div>
                                                    <div class="producttile__productname producttile-productname shimmer"></div>
                                                </div>
                                            </div>
                                            <div class="producttile__footer producttile-footer shimmer"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-lg-4 col-6 plp__item">
                                    <div class="product__tile__react">
                                        <div class="producttile">
                                            <div>
                                                <div class="producttile-img shimmer"></div>
                                                <div>
                                                    <div class="producttile__catclass producttile-catclass eyebrow shimmer"></div>
                                                    <div class="producttile__productname producttile-productname shimmer"></div>
                                                </div>
                                            </div>
                                            <div class="producttile__footer producttile-footer shimmer"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div class="row plp__list">
                                <div class="col-md-3 col-lg-4 col-6 plp__item">
                                    <div class="product__tile__react">
                                        <div class="producttile">
                                            <div>
                                                <div class="producttile-img shimmer"></div>
                                                <div>
                                                    <div class="producttile__catclass producttile-catclass eyebrow shimmer"></div>
                                                    <div class="producttile__productname producttile-productname shimmer"></div>
                                                </div>
                                            </div>
                                            <div class="producttile__footer producttile-footer shimmer"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-lg-4 col-6 plp__item">
                                    <div class="product__tile__react">
                                        <div class="producttile">
                                            <div>
                                                <div class="producttile-img shimmer"></div>
                                                <div>
                                                    <div class="producttile__catclass producttile-catclass eyebrow shimmer"></div>
                                                    <div class="producttile__productname producttile-productname shimmer"></div>
                                                </div>
                                            </div>
                                            <div class="producttile__footer producttile-footer shimmer"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-lg-4 col-6 plp__item">
                                    <div class="product__tile__react">
                                        <div class="producttile">
                                            <div>
                                                <div class="producttile-img shimmer"></div>
                                                <div>
                                                    <div class="producttile__catclass producttile-catclass eyebrow shimmer"></div>
                                                    <div class="producttile__productname producttile-productname shimmer"></div>
                                                </div>
                                            </div>
                                            <div class="producttile__footer producttile-footer shimmer"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-lg-4 col-6 plp__item">
                                    <div class="product__tile__react">
                                        <div class="producttile">
                                            <div>
                                                <div class="producttile-img shimmer"></div>
                                                <div>
                                                    <div class="producttile__catclass producttile-catclass eyebrow shimmer"></div>
                                                    <div class="producttile__productname producttile-productname shimmer"></div>
                                                </div>
                                            </div>
                                            <div class="producttile__footer producttile-footer shimmer"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-lg-4 col-6 plp__item">
                                    <div class="product__tile__react">
                                        <div class="producttile">
                                            <div>
                                                <div class="producttile-img shimmer"></div>
                                                <div>
                                                    <div class="producttile__catclass producttile-catclass eyebrow shimmer"></div>
                                                    <div class="producttile__productname producttile-productname shimmer"></div>
                                                </div>
                                            </div>
                                            <div class="producttile__footer producttile-footer shimmer"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3 col-lg-4 col-6 plp__item">
                                    <div class="product__tile__react">
                                        <div class="producttile">
                                            <div>
                                                <div class="producttile-img shimmer"></div>
                                                <div>
                                                    <div class="producttile__catclass producttile-catclass eyebrow shimmer"></div>
                                                    <div class="producttile__productname producttile-productname shimmer"></div>
                                                </div>
                                            </div>
                                            <div class="producttile__footer producttile-footer shimmer"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};
SearchLazyShimmer.propsType = {
    pageTypeClass: string,
};

SearchLazyShimmer.defaultProps = {
    pageTypeClass: ''
};
export default memo(SearchLazyShimmer);
